import {html} from 'lit';

export const facet7Template = () => html`
    <div class="image-shapes-7--crop-mobile">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 360 270" xml:space="preserve">
            <polygon class="fill-lightblue400" points="359.9,161.1 312.9,188.3 312.9,242.7 359.9,270 "/>
        </svg>
    </div>

    <div class="image-shapes-7">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 380 301" xml:space="preserve">
            <path class="fill-darkblue" d="M356.6,145.9v51.9l-42.3-24.4v-65l31.3,18.1C352.4,130.5,356.6,138,356.6,145.9"/>
            <polygon class="fill-lightblue400" points="356.6,246.5 314.4,270.8 272.3,246.5 272.3,197.9 314.4,173.6 356.6,197.9 "/>
        </svg>
    </div>
`;
